<template>
  <div>
    <div class="logo-band">
      <div class="redemption-logo">
        <img :src="gemnoteLogo" />
      </div>
    </div>
    <Loader v-if="loading" />
    <div v-else>
      <GroupOrderHeaderBand
        isShipping
        :trackingUrl="recipient.trackingUrl"
        :trackingNo="recipient.trackingNumber"
      />
      <div class="group-order-container">
        <GroupOrderRecipientInfo :recipient="recipient" confirmWithSuccess />
        <GroupOrderCartList
          :selectedVariants="selectedVariants"
          confirmWithSuccess
        />
      </div>
      <p>
        For more information on <strong>Gemnote</strong> and corporate gifting.
        please visit our
        <strong>
          <span
            class="hoverable-text"
            @click="openWindowTab('https://www.gemnote.com')"
            >website</span
          >
        </strong>
        and
        <strong>
          <span
            class="hoverable-text"
            @click="openWindowTab('https://www.gemnote.com/blog')"
            >blog!</span
          ></strong
        >
      </p>
    </div>
  </div>
</template>
<script>
import { layouts } from '../../helpers'
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    gemnoteLogo: require('../../assets/gemnote_logo_pebble.png')
  }),
  components: {
    GroupOrderHeaderBand: () => import('./GroupOrderHeaderBand.vue'),
    GroupOrderRecipientInfo: () => import('./GroupOrderRecipientInfo.vue'),
    Loader: () => import('@/components/Loading'),
    GroupOrderCartList: () => import('./GroupOrderCartList.vue')
  },
  mounted() {
    this.shippingDetails()
    this.$store.dispatch('layout/setPageLayout', layouts.GROUP_ORDER_LAYOUT)
  },
  computed: {
    ...mapState({
      recipient: state => state.groupOrder.recipient.recipient,
      loading: state => state.groupOrder.shippingLoading,
      selectedVariants: state => state.groupOrder.selectedVariants
    })
  },
  methods: {
    ...mapActions('groupOrder', ['getRecipientShippingDetails']),
    shippingDetails() {
      this.getRecipientShippingDetails({
        groupOrderId: this.$route.params.groupId,
        token: this.$route.params.token
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/global.scss';

.group-order-container {
  p {
    padding: 2rem;
  }
}

@media (max-width: 1100px) {
  .group-order-container {
    width: 85%;
  }
  .logo-band {
    background: $main-white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 6rem;
  }

  .redemption-logo {
    height: 5.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 9rem;
    img {
      width: inherit;
      height: inherit;
      object-fit: contain;
      padding: 5px;
    }
  }
}
</style>
